import type { Terms } from '@ps/web-martech-cms-types';
import React from 'react';

import CMSGroupBlock from './CMSGroupBlock';

const CMSTerms: React.FC<Terms> = ({ groups, variant }) => (
  // eslint-disable-next-line react/jsx-no-useless-fragment
  <>
    {groups.map((item, index) => (
      <CMSGroupBlock key={index} index={index + 1} {...item} variant={variant} />
    ))}
  </>
);

export default CMSTerms;
